import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFundingTracker = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.64712 5.76389C9.2178 6.06996 8.69243 6.25 8.125 6.25C6.67525 6.25 5.5 5.07475 5.5 3.625C5.5 2.17525 6.67525 1 8.125 1C9.06474 1 9.88915 1.49381 10.3529 2.23611M4 14.5654H5.95772C6.21297 14.5654 6.46666 14.5957 6.71411 14.6565L8.78267 15.1592C9.23151 15.2685 9.69908 15.2791 10.1526 15.1911L12.4397 14.7461C13.0439 14.6284 13.5997 14.3391 14.0353 13.9154L15.6534 12.3413C16.1155 11.8925 16.1155 11.1643 15.6534 10.7148C15.2374 10.3101 14.5785 10.2645 14.1078 10.6077L12.2219 11.9836C11.9519 12.1811 11.6232 12.2874 11.2852 12.2874H9.46412L10.6233 12.2873C11.2767 12.2873 11.8059 11.7725 11.8059 11.1369V10.9069C11.8059 10.3791 11.4367 9.91897 10.9106 9.7914L9.12145 9.35631C8.83029 9.28569 8.5321 9.25 8.23235 9.25C7.50875 9.25 6.19892 9.84911 6.19892 9.84911L4 10.7687M14.5 4.375C14.5 5.82475 13.3247 7 11.875 7C10.4253 7 9.25 5.82475 9.25 4.375C9.25 2.92525 10.4253 1.75 11.875 1.75C13.3247 1.75 14.5 2.92525 14.5 4.375ZM1 10.45L1 14.8C1 15.22 1 15.4301 1.08175 15.5905C1.15365 15.7316 1.26839 15.8463 1.40951 15.9183C1.56994 16 1.77996 16 2.2 16H2.8C3.22004 16 3.43006 16 3.59049 15.9183C3.73161 15.8463 3.84635 15.7316 3.91825 15.5905C4 15.4301 4 15.22 4 14.8V10.45C4 10.03 4 9.81994 3.91825 9.65951C3.84635 9.51839 3.73161 9.40365 3.59049 9.33175C3.43006 9.25 3.22004 9.25 2.8 9.25L2.2 9.25C1.77996 9.25 1.56994 9.25 1.40951 9.33175C1.26839 9.40365 1.15365 9.51839 1.08175 9.65951C1 9.81994 1 10.03 1 10.45Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgFundingTracker);
export default ForwardRef;
